import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/auth/services/auth.service';
import { usernameOrPhoneInputValidator } from '../../shared/validators/username-or-phone-input.validator';

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  invalidCredentials = false;
  logoutMessage: string = '';
  isLoading = false;

  loginForm = new FormGroup({
    username: new FormControl('', [Validators.required, usernameOrPhoneInputValidator()]),
    password : new FormControl('', [Validators.required, Validators.minLength(8)]),
  })

  constructor(
    private readonly router: Router, 
    private readonly authService : AuthService,
    private readonly route: ActivatedRoute
  ){
    this.route.queryParams.subscribe(params => {
      const reason = params['reason'];
      if (reason === 'session-expired') {
        this.logoutMessage = 'Your session has expired. Please log in again.';
      }
    });

    this.loginForm.valueChanges.subscribe(() => {
      if (this.invalidCredentials) {
        this.invalidCredentials = false;
      }
    });
  }

  navigateToResetPassword() {
    this.router.navigate(['reset-password']);
  }

  onSubmit(){
    this.invalidCredentials = false;
    this.logoutMessage = '';

    const username = this.loginForm.get('username')?.value ?? "";
    const password = this.loginForm.get('password')?.value ?? "";

    this.isLoading = true;
    this.authService.login(username, password).subscribe({
      next: () => {
        const user = JSON.parse(localStorage.getItem('user') ?? '{}');
        if (user.role === 'SUPER_ADMIN' || user.role === 'ADMIN') {
          this.router.navigate(['/dashboard/orders']);
        } else if (user.role === 'SALESPERSON') {
          this.router.navigate(['/dashboard/products']);
        } else {
          this.router.navigate(['/dashboard']);
        }
      },
      error: err => {
        this.invalidCredentials = true;
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }
}
